export default __webpack_public_path__ + "static/media/about_tablet-holding-hand.fce4e3e0.png";